module.exports = __webpack_public_path__ + "dae2fec21f7359c4d4a4bd98b876b3fd.mp4";